import { Component, OnInit, ViewChild, Input, ElementRef, OnChanges, SimpleChanges, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AgendamentoEventosModel } from '../../models/agendamento-eventos.model';


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'agendamento-webcomponent-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './agendamento-webcomponent-container.html',
    styleUrls: ['./agendamento-webcomponent-container.scss']
})
export class AgendamentoWebComponentContainerComponent implements OnInit, OnChanges {

    @ViewChild('agendamentoWebComponent', { static: false }) agendamentoWebComponent: ElementRef;

    @Input() Protocolo: any;
    @Output() StatusFinalAgendamento = new EventEmitter<AgendamentoEventosModel>();

    constructor(
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.refresh();
        if (changes['Protocolo']) {
            this.agendamentoWebComponent.nativeElement.Config = { Protocolo: this.Protocolo };

        }
    }

    ngOnInit() {
        this.refresh();
        this.agendamentoWebComponent.nativeElement.addEventListener('StatusFinalAgendamento', this.emitAgendamentoStatus.bind(this));
    }

    emitAgendamentoStatus(event) {
        this.refresh();
        this.StatusFinalAgendamento.emit(event.detail);
    }

    private refresh() {
        this.cdr.detectChanges();
    }
}
